import { datadogRum } from '@datadog/browser-rum';

// Initiate DataDog Real User Monitoring
try {
  datadogRum.init({
    applicationId: '06c39d3b-e3b8-42c4-9458-918779b7e2ca',
    clientToken: 'pub4fab6163de6be9977cd101fe6d3c8344',
    site: 'datadoghq.com',
    service:'digital-form-emis',
    env: parseDatadogEnv(),
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.VUE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackFrustrations: true,
    defaultPrivacyLevel:'mask-user-input',
    allowedTracingUrls: [
      (url) => url.startsWith("https://api-uat.aham.com.my"),
      (url) => url.startsWith("https://api-prod.aham.com.my")
    ]
  })
  datadogRum.startSessionReplayRecording()
} catch (err) {
  console.log('Error in DataDog RUM', err)
}

function parseDatadogEnv() {
  if (process.env.NODE_ENV === 'production') {
    return 'prod'
  } else if (process.env.NODE_ENV === 'uat') {
    return 'preprod'
  } else if (process.env.NODE_ENV === 'staging') {
    return 'dev'
  } else if (process.env.NODE_ENV === 'development') {
    return 'development'
  } else {
    return null
  }
}

export default datadogRum